import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from './services/config.service';
import { UiService } from './services/ui/ui.service';
import { LocaleService } from './services/locale/locale.service';
import { UserManagerService } from './services/user-manager/user-manager.service';
import { NavigationEnd, Router } from '@angular/router';
import { SportServicesService } from './services/sport-service/sport-services.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SESSION_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { STORAGE_KEYS } from '@enum/storage-keys.enum';
// import { PrimeNGConfig } from 'primeng/api';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'admin-sportif';
  subscription = new Subscription();
  constructor(private translate: TranslateService,
              // private primengConfig: PrimeNGConfig,
              private localeService: LocaleService,
              private configService: ConfigService,
              private sportService: SportServicesService,
              private router: Router,
              private userService: UserManagerService,
              @Inject(SESSION_STORAGE) private storage: WebStorageService,
              private uiService: UiService) {
    // this.configService.loadConfigs();
    // translate.setDefaultLang('en');
    this.initializeTheme();
    this.configureAppLanguage();
  }

  ngOnInit(): void {
    // Store
    this.subscription.add(this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentUrl = event.urlAfterRedirects || event.url;
        if(!currentUrl.includes('login')){
          const session = {
            login: this.userService.isLoggedIn,
            data: this.userService.logindata,
            params: this.sportService.parameters,
            path: '/#' + currentUrl
          };
          this.storage.set(STORAGE_KEYS.LOGIN, session);
        }
      })
    );

    this.subscription.add(
      this.configService.$config.subscribe((v) => {
        this.subscription.add(
          this.configService.getSystemConfigs().subscribe()
        );
      })
    );
  }

  configureAppLanguage() {
    const navigatorLanguage = this.translate.getBrowserLang();
    const defaultLang = this.uiService.getSupportedLanguage(navigatorLanguage);
    this.configService.lang = defaultLang;
    this.uiService.setDefaultLanguage(defaultLang);

    this.subscription.add(this.translate.onLangChange.subscribe(event => {
      this.localeService.setLocale(event.lang);
    }));
  }

  initializeTheme() {
    // this.primengConfig.ripple = true;
    for (const property of Object.keys(this.uiService.theme.properties)) {
      document.documentElement.style.setProperty(property, this.uiService.theme.properties[property]);
    }
    // this.uiService.theme.properties.forEach(property => {
    //   console.log('property is ', property);
    //   document.documentElement.style.setProperty(property, this.uiService.theme.properties[property]);
    // });
  }

  ngOnDestroy(): void {
      this.subscription.unsubscribe();
  }
}
